import { Resources } from '@app/resources';
import { MenuItem } from '@app/layouts/sidebar/menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'MENU.DASHBOARD',
    icon: 'las la-chart-pie',
    link: Resources.Dashboard,
    permissions: [
      'dashboard-reports',
    ]
  },
  {
    id: 34,
    label: 'MENU.PROPERTY_MANAGEMENT',
    link: Resources.PropertyManagement,
    icon: 'las la-building',
    subItems: [
      {
        id: 31,
        label: 'MENU.PROPERTIES_PORTFOLIO',
        parentId: 34,
        link: Resources.Properties,
        icon: 'las la-building',
        permissions: ['buildings.index',
          'buildings.store',
          'buildings.update',
          'buildings.show',
          'buildings.destroy',
          'buildings.generate-code',
          'buildings.responsible-user'
        ]
      }, {
        id: 32,
        label: 'PROPERTY.TAB.CONTRACTS',
        parentId: 34,
        link: Resources.PropertyContracts,
        icon: 'la la-file-contract',
        permissions: ['rental-contracts.index',
          'rental-contracts.store',
          'rental-contracts.update',
          'rental-contracts.show',
          'rental-contracts.destroy',
          'rental-contracts.pdf',
          'rental-contracts.contract-export-data',

        ]
      },
    ]
  },
  {
    id: 2,
    label: 'MENU.UNIVERSAL_BILLING',
    icon: 'las la-file-invoice-dollar',
    subItems: [
      {
        id: 15,
        label: 'MENU.SMART_METERS',
        parentId: 11,
        link: Resources.SmartBilling,
        icon: 'las la-tachometer-alt',
      },
      {
        id: 12,
        label: 'COMPANIES.COMPANIES',
        parentId: 2,
        link: Resources.Renters,
        icon: 'las la-building',
        permissions: ['companies.index',
        ]
      },
      {
        id: 10,
        label: 'MENU.BILLING',
        parentId: 2,
        link: Resources.Invoices,
        icon: 'las la-file-invoice',
        permissions: ['invoices.index',
          'invoices.update-payment-status',
          'invoices.show',
          'invoices.destroy',
          'invoices.generate',
          'invoices.manual-generate',
          'invoices.blueprint',
          'invoices.qr-code',
          'invoices.pdf',
          'invoices.patch',
          'invoices.generation-types',
        ]
      },
      {
        id: 5,
        label: 'MENU.DASHBOARD',
        parentId: 2,
        link: Resources.UniversalBilling,
        icon: 'las la-tachometer-alt',
      },

      /**{
       id: 7,
       label: 'MENU.APARTMENTS',
       parentId: 12,
       link: Resources.UniversalBillingApartments,
       icon: 'las la-home',
       },
       {
       id: 8,
       label: 'MENU.RESIDENTS',
       parentId: 2,
       link: Resources.Residents,
       icon: 'las la-user-friends',
       },
       {
       id: 9,
       label: 'MENU.READINGS',
       parentId: 2,
       link: Resources.Readings,
       icon: 'las la-bolt',
       },*/

    ],
  },
  {
    id: 6,
    label: 'MENU.ACCOUNTING',
    icon: 'las la-calculator',
    subItems: [
      {
        id: 11,
        label: 'MENU.TRANSACTIONS',
        parentId: 6,
        link: Resources.Payments,
        icon: 'las la-money-check-alt',
        permissions: ['payments.index',
        ]
      },
      {
        label: 'MENU.BOOKINGS',
        parentId: 6,
        link: Resources.Bookings,
        icon: 'ri-calendar-line',
        permissions: ['datevbookings.index',
        ]
      },
      {
        label: 'MAIN.DOCUMENTS',
        parentId: 6,
        link: Resources.Documents,
        icon: 'las la-file',
        permissions: ['documents.index',
        ]
      },
    ],
  },
  {
    id: 3,
    label: 'MENU.SETTINGS',
    icon: 'las la-cog',
    subItems: [
      {
        id: 18,
        label: 'MENU.SYSTEM_SETTINGS',
        parentId: 11,
        link: Resources.SettingsSettings,
        icon: 'las la-cog',
      },
      {
        id: 14,
        label: 'MENU.UNIT_TYPES',
        parentId: 13,
        link: Resources.SettingsUnitTypes,
        icon: 'las la-radiation',
        permissions: ['unit-types.index']
      },
      {
        id: 13,
        label: 'MENU.ADDRESSES',
        parentId: 11,
        icon: 'las la-globe',
        link: Resources.SettingsAddresses,
        permissions: [
          'address-books.index',
        ]
        // subItems: [
        //   {
        //     id: 18,
        //     label: 'MENU.STATES',
        //     parentId: 13,
        //     link: Resources.SettingsStates,
        //     icon: 'las la-globe',
        //   },
        //   {
        //     id: 19,
        //     label: 'MENU.CITIES',
        //     parentId: 13,
        //     link: Resources.SettingsCities,
        //     icon: 'las la-city',
        //   },
        //   {
        //     id: 20,
        //     label: 'MENU.STREETS',
        //     parentId: 13,
        //     link: Resources.SettingsStreets,
        //     icon: 'las la-road',
        //   },
        //   // {
        //   //   id: 21,
        //   //   label: 'MENU.PROPERTIES',
        //   //   parentId: 13,
        //   //   link: Resources.SettingsProperties,
        //   //   icon: 'las la-building',
        //   // },
        //   // {
        //   //   id: 22,
        //   //   label: 'MENU.APARTMENTS',
        //   //   parentId: 13,
        //   //   link: Resources.SettingsApartments,
        //   //   icon: 'las la-home',
        //   // },
        // ]
      },


      // {
      //   id: 15,
      //   label: 'MENU.TARIFFS',
      //   parentId: 11,
      //   link: Resources.SettingsTariffs,
      //   icon: 'las la-tag',
      // },
      // Uncomment if needed
      // {
      //   id: 16,
      //   label: 'MENU.TAXES',
      //   parentId: 11,
      //   link: Resources.SettingsTaxes,
      //   icon: 'las la-percentage',
      // },
      // {
      //   id: 16,
      //   label: 'MENU.USERS',
      //   parentId: 11,
      //   link: Resources.SettingsUsers,
      //   icon: 'las la-users',
      // },
      // {
      //   id: 17,
      //   label: 'MENU.ROLES',
      //   parentId: 11,
      //   link: Resources.SettingsRoles,
      //   icon: 'las la-users-cog',
      // },
      {
        id: 17,
        label: 'MENU.TRANSLATIONS',
        parentId: 11,
        link: Resources.SettingsTranslations,
        icon: 'las la-language',
        permissions: [
          'translations.index',
        ]
      },

      {
        id: 19,
        label: 'ACTIONS.COMPANIES',
        parentId: 13,
        link: Resources.SettingsCompanies,
        icon: 'las la-building',
        permissions: ['companies.index', 'companies.store', 'companies.update', 'companies.destroy']
      },
      {
        id: 18,
        label: 'ACTIVITY_LOGS.TITLE',
        parentId: 11,
        link: Resources.SettingsActivityLogs,
        icon: 'las la-history',
        permissions: ['activity-logs']
      },
    ]
  },
  // {
  //   id: 4,
  //   label: 'MENU.SMART_BUILDING',
  //   icon: 'las la-building',
  //   subItems: [
  //     {
  //       id: 23,
  //       label: 'MENU.SMART_CONTROLLER',
  //       icon: 'las la-microchip',
  //       subItems: [
  //         {
  //           id: 26,
  //           label: 'MENU.HOME_CONTROLLER',
  //           parentId: 23,
  //           link: Resources.HomeController,
  //           icon: 'las la-home',
  //         },
  //         {
  //           id: 27,
  //           label: 'MENU.3D_CONTROLLER',
  //           link: Resources.ThreeDController,
  //           parentId: 23,
  //           icon: 'las la-cube',
  //         },
  //       ],
  //     },
  //     {
  //       id: 24,
  //       label: 'MENU.BUILDING_PLAN',
  //       icon: 'las la-map',
  //       link: Resources.BuildingPlan,
  //     },
  //     {
  //       id: 25,
  //       label: 'MENU.DEVICES',
  //       icon: 'las la-tablet-alt',
  //       subItems: [
  //         {
  //           id: 28,
  //           label: 'MENU.ADD_DEVICE',
  //           parentId: 25,
  //           link: Resources.AddDevice,
  //           icon: 'las la-plus',
  //         },
  //         {
  //           id: 29,
  //           label: 'MENU.DEVICE_CATEGORY',
  //           link: Resources.DeviceCategory,
  //           parentId: 25,
  //           icon: 'las la-layer-group',
  //         },
  //         {
  //           id: 30,
  //           label: 'MENU.MANAGE_DEVICE',
  //           link: Resources.ManageDevice,
  //           parentId: 25,
  //           icon: 'las la-tools',
  //         },
  //         {
  //           id: 31,
  //           label: 'MENU.MANAGE_DEVICE',
  //           link: Resources.ManageDevice,
  //           parentId: 25,
  //           icon: 'ri-font-size',
  //         },
  //       ],
  //     },
  //   ],
  // }
];
